<div
  class="input-container"
  [ngClass]="{ relative: options || isLoadingOptions }"
>
  <div class="input-container__wrapper">
    <label
      [for]="id"
      class="input-container__wrapper__label"
      [ngClass]="{
        '!text-mg-error': error,
        'text-mg-primary-50': disabled,
        'text-mg-neutral-light': !error,
        '!text-mg-primary': (isFocused || active) && !error,
      }"
    >
      {{ label }}
    </label>
    <span *ngIf="currency" class="input-container__wrapper__currency">{{
      currency
    }}</span>
    <input
      #input
      (click)="onInputClick()"
      (keypress.enter)="onInputClick()"
      (keypress.space)="onInputClick()"
      (focus)="onFocus()"
      [id]="id"
      [name]="id"
      class="input-container__wrapper__input"
      [tabIndex]="disabled ? -1 : undefined"
      [ngClass]="{
        '!border-mg-error': error,
        '!border-mg-primary-50 placeholder:select-none placeholder:!text-mg-primary-50':
          disabled,
        'pr-9': tooltip || type === 'password' || clearable,
        '!pl-9': currency,
        '!rounded-b-none': showOptions && (options || isLoadingOptions),
      }"
      [formControl]="control"
      [type]="type"
      [maxlength]="maxLength"
      [maxLength]="maxLength"
      [placeholder]="placeholder"
      [value]="value"
      (blur)="onBlur()"
      (mousedown)="onActive()"
      (mouseup)="onInactive()"
      [autocomplete]="autocompleteType"
      (focus)="focus($event)"
      (keydown)="handleKeyDown($event)"
      [attr.data-autofocus]="autofocus ? true : null"
      (focus)="focus($event)"
    />

    <div
      class="icon-container"
      [ngClass]="{
        '!text-mg-primary-50': disabled,
        '!text-mg-error': error,
        'tooltip-container': mgTitle !== undefined,
      }"
    >
      <ng-container *ngIf="mgTitle">
        <span class="tooltip-text">{{ mgTitle }}</span>
      </ng-container>
      <mg-icons
        class="w-6"
        *ngIf="originalType === 'password'"
        (click)="togglePasswordVisibility()"
        (keypress.enter)="togglePasswordVisibility()"
        (keydown.space)="togglePasswordVisibility()"
        [ngClass]="{
          'text-mg-error': error,
          'text-mg-primary-50': disabled,
          'text-mg-neutral-light': !error,
          'text-mg-primary': active || (isFocused && !error),
        }"
        [name]="iconName"
      ></mg-icons>
      <mg-icons
        class="w-6 cursor-pointer"
        *ngIf="clearable && control.value && !disabled"
        role="button"
        tabindex="0"
        aria-label="Clear input"
        (click)="clearInput()"
        (keypress.enter)="clearInput()"
        (keydown.space)="clearInput()"
        [ngClass]="{
          'text-mg-error': error,
          'text-mg-neutral-light': !error,
          'text-mg-primary': active || (isFocused && !error),
        }"
        name="closeCircle"
      >
      </mg-icons>
      <mg-icons
        [ngClass]="{
          'text-mg-error': error,
          'text-mg-primary-50': disabled,
          'text-mg-neutral-light': !error,
          'text-mg-primary': active || (isFocused && !error),
        }"
        *ngIf="tooltip"
        ngxTippy
        #tippyInstance
        data-tippy-arrow="true"
        [tippyProps]="{
          arrow: true,
          content: tooltip,
          hideOnClick: false,
        }"
        [attr.aria-describedby]="'tooltip'"
        name="info-circle"
      ></mg-icons>
      <mg-icons
        *ngIf="
          control.touched &&
          showValidator &&
          !tooltip &&
          originalType !== 'password'
        "
        [name]="setIconValidIndicator"
      ></mg-icons>
      <mg-icons
        *ngIf="mgIcon"
        [name]="mgIcon"
        (click)="onIconClick()"
        (keypress.enter)="onIconClick()"
        (keypress.space)="onIconClick()"
        [matTooltipDisabled]="mgTitlev2 === null"
        [matTooltip]="mgTitlev2 ?? ''"
        matTooltipPosition="above"
        matTooltipClass="custom-tooltip"
      >
      </mg-icons>
    </div>
  </div>
  <ng-container *ngIf="showOptions">
    <ng-container *ngIf="isLoadingOptions">
      <div class="input-container__options">
        <div class="justify-center input-container__options__option">
          <img
            src="../../../assets/img/dual_ring_animation-black.svg"
            alt="loading"
            class="w-10 h-10"
          />
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="options && options.length > 0">
      <div class="input-container__options">
        <ng-container *ngFor="let option of options">
          <div
            class="input-container__options__option"
            (click)="handleSelect(option)"
            (keypress.enter)="handleSelect(option)"
            (keypress.space)="handleSelect(option)"
          >
            <span class="input-container__options__option__text">{{
              option.name
            }}</span>
          </div>
        </ng-container>
      </div>
    </ng-container>
    <ng-container *ngIf="!isLoadingOptions && options?.length === 0">
      <div class="input-container__options">
        <div class="input-container__options__option">
          <span class="justify-center input-container__options__option__text"
            >Sin resultados</span
          >
        </div>
      </div>
    </ng-container>
  </ng-container>

  <div></div>
  <p *ngIf="error && !disabled" class="input-container__error">
    {{ getErrors(control.errors) }}
  </p>
</div>
